export default "__VITE_ASSET__Bwpr9vRK__"